<template>
    <div class="artist-card-review" :class="{ 'w-75': mode === 'relevantArtist' }">
        <img :src="artistInfo.profile_picture" class="artist-photo" />
        <div class="artist-card-content">
            <div class="header-info">
                <div class="d-flex flex-column" :class="{ 'w-100': width < 600 }">
                    <div class="title-card-info">
                        <a
                            :href="'/artists/' + artistInfo.slug"
                            target="_blank"
                            class="artist-name me-4"
                        >
                            {{ artistInfo.artist_name }}
                        </a>
                        <div v-if="artistInfo.rating >= 4" class="d-flex align-items-center">
                            <img :src="getIcon + 'Star1.png'" alt="" class="social-img" />
                            <p class="artist-name">{{ artistInfo.rating }}</p>
                        </div>
                    </div>
                    <p v-if="mode === 'relevantArtist'" class="min-rate-artist">
                        starting at <span>${{ artistInfo.min_rate }}</span>
                    </p>
                </div>
                <button
                    v-if="!mode && width > 600"
                    class="go-back-to-all"
                    @click="goToAllOffers"
                >
                    Go Back to All Offers
                </button>
                <div v-if="mode === 'relevantArtist'" class="btn-container">
                    <button class="go-back-to-all">Book</button>
                    <button class="go-back-to-all" @click="saveToContacts">
                        Save to contacts
                    </button>
                </div>
            </div>
            <div
                class="location-container"
                :class="{ 'align-center': width > 600, 'flex-column': width < 600 }"
            >
                <p v-if="width < 600" class="location-info">
                    Based in {{ artistInfo.location }}
                </p>
                <div v-if="width < 600" class="social-container">
                    <div
                        v-if="artistInfo.followers_by_social.instagramStat"
                        class="social-information"
                    >
                        <img :src="getIcon + 'inst-social.png'" />
                        <p class="social-title">
                            {{
                                this.formatSummedValue(
                                    artistInfo.followers_by_social.instagramStat[0].followers
                                )
                            }}
                        </p>
                    </div>
                    <div
                        v-if="artistInfo.followers_by_social.tiktokStat"
                        class="social-information"
                    >
                        <img :src="getIcon + 'icons/tiktok.svg'" />
                        <p class="social-title">
                            {{
                                this.formatSummedValue(
                                    artistInfo.followers_by_social.tiktokStat[0].followers
                                )
                            }}
                        </p>
                    </div>
                    <div
                        v-if="artistInfo.followers_by_social.youtubeStat"
                        class="social-information"
                    >
                        <img :src="getIcon + 'icons/youtube-grey.svg'" />
                        <p class="social-title">
                            {{
                                this.formatSummedValue(
                                    artistInfo.followers_by_social.youtubeStat[0].followers
                                )
                            }}
                        </p>
                    </div>
                    <div
                        v-if="artistInfo.followers_by_social.facebookStat"
                        class="social-information"
                    >
                        <img :src="getIcon + 'spotify-icon.png'" />
                        <p class="social-title">
                            {{
                                this.formatSummedValue(
                                    artistInfo.followers_by_social.facebookStat[0].followers
                                )
                            }}
                        </p>
                    </div>
                    <div
                        v-if="artistInfo.followers_by_social.twitterStat"
                        class="social-information"
                    >
                        <img :src="getIcon + 'cloud-icon.png'" />
                        <p class="social-title">
                            {{
                                this.formatSummedValue(
                                    artistInfo.followers_by_social.twitterStat[0].followers
                                )
                            }}
                        </p>
                    </div>
                </div>
                <p v-if="width > 600" class="location-info">
                    Based in {{ artistInfo.location }}
                </p>
                <div v-if="artistInfo.genres" class="pills-info">
                    <p v-for="(genre, index) in artistInfo.genres.split(',')" :key="index">
                        {{ genre }}
                    </p>
                </div>
            </div>
            <p class="description-offer" :class="{ 'show-description': readMore }">
                {{ artistInfo.description }}
            </p>
            <p
                v-if="
                    artistInfo.description ? artistInfo.description.split('').length > 40 : ''
                "
                class="read-more"
                @click="readMore = !readMore"
            >
                {{ !readMore ? 'Read More' : 'Show less' }}
            </p>
            <hr v-if="width > 600" style="background: #8b8b8b" />
            <div class="followers" v-if="width > 600">
                <div v-if="artistInfo.social_reach" class="total-information">
                    <p class="total-people">
                        {{ this.formatSummedValue(artistInfo.social_reach) }}
                    </p>
                    <p class="information-title">Followers</p>
                </div>
                <div v-if="artistInfo.mounth_listen" class="total-information">
                    <p class="total-people">12K</p>
                    <p class="information-title">Monthly Listeners</p>
                </div>
                <div v-if="artistInfo.followers_average_age" class="total-information">
                    <p class="total-people">{{ artistInfo.followers_average_age }}</p>
                    <p class="information-title">Average Fan Age</p>
                </div>
            </div>
            <div v-if="width > 600" class="social-container">
                <div
                    v-if="artistInfo.followers_by_social.instagramStat"
                    class="social-information"
                >
                    <img :src="getIcon + 'inst-social.png'" />
                    <p class="social-title">
                        {{
                            this.formatSummedValue(
                                artistInfo.followers_by_social.instagramStat[0].followers
                            )
                        }}
                    </p>
                </div>
                <div
                    v-if="artistInfo.followers_by_social.tiktokStat"
                    class="social-information"
                >
                    <img :src="getIcon + 'icons/tiktok.svg'" />
                    <p class="social-title">
                        {{
                            this.formatSummedValue(
                                artistInfo.followers_by_social.tiktokStat[0].followers
                            )
                        }}
                    </p>
                </div>
                <div
                    v-if="artistInfo.followers_by_social.youtubeStat"
                    class="social-information"
                >
                    <img :src="getIcon + 'icons/youtube-grey.svg'" />
                    <p class="social-title">
                        {{
                            this.formatSummedValue(
                                artistInfo.followers_by_social.youtubeStat[0].followers
                            )
                        }}
                    </p>
                </div>
                <div
                    v-if="artistInfo.followers_by_social.facebookStat"
                    class="social-information py-3"
                >
                    <img :src="getIcon + 'spotify-icon.png'" />
                    <p class="social-title">
                        {{
                            this.formatSummedValue(
                                artistInfo.followers_by_social.facebookStat[0].followers
                            )
                        }}
                    </p>
                </div>
                <div
                    v-if="artistInfo.followers_by_social.twitterStat"
                    class="social-information"
                >
                    <img :src="getIcon + 'cloud-icon.png'" />
                    <p class="social-title">
                        {{
                            this.formatSummedValue(
                                artistInfo.followers_by_social.twitterStat[0].followers
                            )
                        }}
                    </p>
                </div>
                <!-- HPT-2178 remove age graph -->
                <div v-if="width > 600" class="line-chart-age d-none">
                    <LineChart
                        ref="eventBudgetModal"
                        :width="440"
                        :selectedDataLine="chartLineBar"
                        :selectedOptionsLine="chartOptions"
                        :height="chartHeight"
                    />
                </div>
            </div>
            <div v-if="artistInfo.top_fan_cities.length" class="top-city">
                <p class="top-cities">Top Fan Cities:</p>
                <p
                    class="top-city-text"
                    v-for="(city, index) in artistInfo.top_fan_cities"
                    :key="index"
                >
                    {{ city }}
                </p>
            </div>
            <hr style="background: #8b8b8b" />
            <div v-if="artistInfo.audios" class="audio-wrapper">
                <div
                    class="player sound-content"
                    v-for="(audio, index) in artistInfo.audios"
                    :key="index"
                >
                    <div class="js-audios-container" @mouseenter="onAudioEnter">
                        <div
                            class="artist-audio custom-audio-element d-flex align-items-center justify-content-evenly"
                            :data-audio-idx="audio.id"
                        >
                            <audio hidden class="d-none" :data-audio-idx="audio.id">
                                <source :src="audio.url" type="audio/mp3" />
                            </audio>
                            <div class="position-relative">
                                <button
                                    class="btn btn-without-focus btn-profile-sound js-profile-btn btn-profile-sound-play play js-play-audio"
                                ></button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p class="song-name">
                            {{ audio.title }}
                        </p>
                    </div>
                    <div>
                        <p class="song-name">
                            {{ audio.duration }}
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="width < 600">
                <hr style="background: #8b8b8b" />
                <button v-if="!mode" class="go-back-to-all" @click="goToAllOffers">
                    Go Back to All Offers
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import LineChart from '../../chart-line/LineChart.vue'
    import { notification } from '../../../../helpers/notification'
    import checkScreen from '../../../../mixins/check-screen'

    export default {
        name: 'ReviewOffersPage',
        components: { LineChart },
        mixins: [checkScreen],
        props: {
            bidArtist: {
                type: Number
            },
            artistInfo: {
                type: Object
            },
            mode: {
                type: String
            }
        },
        data: () => ({
            artistInfo: {},
            offerMode: '',
            averageAge: {},
            chartHeight: 50,
            readMore: false
        }),
        methods: {
            goToArtistPage(artist) {
                window.location.href = `artists/${artist.slug}`
            },
            async saveToContacts() {
                try {
                    const response = await axios.post('/profile/contacts/user', {
                        artist_id: this.artistInfo.id
                    })
                    notification('success', response.data.message)
                } catch (error) {
                    notification('error', error.response.data.errors.message)
                }
            },
            async getArtistInfo() {
                const result = await axios.get(
                    '/api/artist-offer/' + this.bidArtist + '/artist-info'
                )
                this.artistInfo = result.data.data
                this.averageAge = result.data.data.followers_age_range
            },
            onAudioEnter() {
                window.__initAudioElements()
                window.__pauseOtherAudios()
            },
            goToAllOffers() {
                this.offerMode = 'showAll'
                this.$emit('update:offerMode', this.offerMode)
            },
            formatSummedValue(num) {
                if (num >= 1_000_000_000) {
                    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
                }
                if (num >= 1_000_000) {
                    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
                }
                if (num >= 1_000) {
                    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
                }
                if (num <= 0 || !num) {
                    return 'N/A'
                }
                return num.toFixed(0).toString()
            }
        },
        computed: {
            getIcon() {
                return '/images/'
            },
            chartLineBar() {
                const keysArray = Object.keys(this.averageAge)
                const valuesArray = Object.values(this.averageAge)
                return {
                    labels: keysArray,
                    datasets: [
                        {
                            data: valuesArray,
                            borderColor: '#ACACAC',
                            fill: true,
                            tension: 0.4,
                            pointRadius: 0,
                            borderWidth: 1
                        }
                    ]
                }
            },
            chartOptions() {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            display: true,
                            ticks: {
                                callback: (value, index, values) => {
                                    if (index === 0 || index === values.length - 1) {
                                        return value
                                    } else {
                                        return ''
                                    }
                                }
                            },
                            grid: {
                                color: 'grey',
                                borderColor: 'grey',
                                tickColor: 'grey'
                            }
                        },
                        y: {
                            display: false
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        }
                    }
                }
            }
        },
        async created() {
            await this.getArtistInfo()
            localStorage.setItem('artistName', this.artistInfo.artist_name)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .top-cities {
        color: $lighter-grey;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
        margin: 0;
    }
    .read-more {
        color: $lighter-grey;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }
    .audio-wrapper {
        display: flex;
        gap: 26px;
        align-items: center;
        overflow-y: scroll;
    }
    .btn-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .min-rate-artist {
        color: $lighter-grey;
        @include base-font-24;
        line-height: 110%;
        letter-spacing: -0.96px;
    }
    .min-rate-artist span {
        color: $lighter-grey;
        @include base-font-32;
        font-weight: 700;
        line-height: 110%;
        letter-spacing: -1.28px;
    }
    .line-chart-age {
        max-width: 238px;
        margin-left: auto;
    }
    .btn-profile-sound-play {
        background-image: url(/images/play-button.png);
    }
    .artist-photo {
        min-width: 250px;
        max-width: 320px;
        max-height: 452px;
        object-fit: cover;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
    }
    .song-name {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
        margin-bottom: 0;
    }
    .social-information img {
        max-width: 22px;
        max-height: 22px;
    }
    .social-information p {
        color: $white;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .social-container {
        display: flex;
        gap: 20px;
        max-width: 50%;
    }
    .social-information {
        display: flex;
        gap: 6px;
    }
    .information-title {
        color: $lighter-grey;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
    }
    .total-people {
        color: $white;
        @include base-font-32;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .total-information {
        display: flex;
        align-items: baseline;
        gap: 6px;
    }
    .followers {
        display: flex;
        gap: 30px;
    }
    .artist-name {
        margin: 0;
        cursor: pointer;
        text-decoration: none;
        color: $white;
    }
    .location-info {
        color: $lighter-grey;
        @include base-font-14;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .description-offer {
        overflow: hidden;
        color: $lighter-grey;
        text-overflow: ellipsis;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
        max-width: 100%;
        max-height: 42px;
        word-break: break-all;
        white-space: initial;
        margin: 0;
    }
    .title-card-info {
        color: $white;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
        align-items: center;
        margin-bottom: 20px;
        display: flex;
    }
    .artist-card-review {
        display: flex;
        border-radius: 15px;
        background: $dark;
        overflow: hidden;
    }
    .artist-card-content {
        flex: 0 1 80%;
        padding: 20px 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        max-width: 780px;
    }
    .sound-content {
        display: flex;
        gap: 6px;
        min-width: 200px;
    }
    .top-city {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 10px;
        align-items: center;
    }
    .top-city-text {
        color: $lighter-grey;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        margin: 0;
    }
    .pills-info {
        display: flex;
        gap: 10px;
        overflow-y: scroll;
    }
    .location-container {
        display: flex;
        gap: 12px;
    }
    .pills-info p {
        border-radius: 100px;
        border: 1px solid $lighter-grey;
        color: $lighter-grey;
        @include base-font-12;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        min-width: max-content;
        padding: 3px 10px 4px 10px;
    }
    .go-back-to-all {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: $lime-2;
        color: $dark;
        @include base-font-18;
        font-weight: 600;
        line-height: 120%;
        border: 0;
        max-height: 45px;
        padding: 10px 30px;
    }
    .social-img {
        max-height: 18px;
        max-width: 18px;
    }
    .header-info {
        display: flex;
        justify-content: space-between;
    }
    .show-description {
        max-height: max-content;
    }
    @media (max-width: 600px) {
        .artist-card-review {
            flex-wrap: wrap;
            margin: 0 16px;
        }
        .artist-photo {
            min-width: 100%;
            max-height: 220px;
            border-radius: 15px 15px 0 0;
        }
        .artist-name {
            font-size: 20px;
        }
        .location-info {
            margin: 0;
        }
        .sound-content {
            min-width: max-content;
            align-items: end;
        }
        .audio-wrapper {
            max-width: 320px;
            overflow-y: scroll;
        }
        .artist-card-content {
            max-width: 100%;
        }
        .go-back-to-all {
            width: 100%;
        }
        .title-card-info {
            width: 100%;
            justify-content: space-between;
            margin-bottom: 0;
        }
    }
</style>
